import _regeneratorRuntime from "/opt/build/repo/node_modules/@babel/runtime/regenerator";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { useState as t, useLayoutEffect as e, useEffect as o, useMemo as r } from "react";
import { set as s, get as n } from "idb-keyval";

var a = function a(_a, i) {
  var _ = "___usePersistentDismissable___" + _a,
      _t = t(i),
      _t2 = _slicedToArray(_t, 2),
      c = _t2[0],
      l = _t2[1],
      m = function m() {
    return l(!0);
  },
      p = function p() {
    return l(!1);
  };

  return e(function () {
    var t = !1;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var e;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return n(_);

            case 2:
              e = _context.sent;
              t || l(Boolean(e));

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))(), function () {
      t = !0;
    };
  }, [_]), o(function () {
    s(_, Boolean(c));
  }, [c, _]), r(function () {
    return [c, m, p];
  }, [c]);
};

export { a as usePersistentDismissable };